const breakpoints = ["320px", "768px", "1025px", "1440px"];

// aliases
breakpoints.sm = breakpoints[0];
breakpoints.md = breakpoints[1];
breakpoints.lg = breakpoints[2];
breakpoints.xl = breakpoints[3];

const PRODUCTION = process.env.NODE_ENV === "production";
// const publicPath = PRODUCTION ? "/vue-lazy-loans/" : "/";
const publicPath = "/";

const defaultTheme = {
   imagePath: publicPath + "images",
   copyPath: publicPath + "content/copy",
   appDataPath: publicPath + "app-data",
   breakpoints,
   fontFamily: "Verdana",
   fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 96, 128].map((e) => e + "px"),
   fontWeights: ["normal", "bold", 100, 200, 300, 400],
   lineHeights: [14, 16, 24, 32, 48, 64, 96, 128].map((e) => e + "px"),
   sizes: [
      0,
      (1 / 12) * 100 + "%",
      (2 / 12) * 100 + "%",
      (3 / 12) * 100 + "%",
      (4 / 12) * 100 + "%",
      (5 / 12) * 100 + "%",
      (6 / 12) * 100 + "%",
      (7 / 12) * 100 + "%",
      (8 / 12) * 100 + "%",
      (9 / 12) * 100 + "%",
      (10 / 12) * 100 + "%",
      (11 / 12) * 100 + "%",
      (12 / 12) * 100 + "%",
   ],
   space: [
      // margin and padding
      0,
      4,
      8,
      12,
      16,
      20,
      24,
      28,
      32,
   ].map((e) => e + "px"),
   primaryColor: "green",
   secondaryColor: "yellow",
   // primaryColor: "#007582",
   // secondaryColor: "rgb(247, 144, 18)",
   logo: "lorem-ipsum-bank-logo.png",
   colors: {
      blue: "#07c",
      red: "#e10",
      green: "#d2f5e5",
   },
};

const themes = {
   purple: {
      ...defaultTheme,
      name: "purple",
      primaryColor: "#007582",
      secondaryColor: "rgb(247, 144, 18)",
      logo: "lorem-ipsum-bank-logo.png",
   },
   red: {
      ...defaultTheme,
      name: "red",
      primaryColor: "red",
      secondaryColor: "rgb(247, 144, 18)",
      logo: "generic-logo.png",
   },
   blue: {
      ...defaultTheme,
      name: "blue",
      primaryColor: "blue",
      secondaryColor: "rgb(247, 144, 18)",
      logo: "generic-logo2.svg",
   },
};

var index = {
   namespaced: true,
   state: {
      theme: defaultTheme,
   },
   mutations: {
      setTheme(state, themeName) {
         state.theme = themes[themeName];
      },
   },
};

export default index;
